import { useEffect } from "react";

import { subscribeToCable } from "../lib/cable";

export type ProductChannelEvent = {
  event: "parsed" | "parse_failed" | "files_updated" | "files_error" | "fingerprint_updated" | "fingerprint_failed";
  product_id?: number;
  error_message?: string;
};

const KNOWN_EVENTS: ProductChannelEvent["event"][] = [
  "parsed",
  "parse_failed",
  "files_updated",
  "files_error",
  "fingerprint_updated",
  "fingerprint_failed",
];

export default function useProductParseSocket(
  productId: number,
  onMessage: (event: ProductChannelEvent) => void
) {
  useEffect(() => {
    return subscribeToCable<ProductChannelEvent>({
      channel: "ProductChannel",
      params: { product_id: productId },
      onMessage: (data) => {
        if (!data || !KNOWN_EVENTS.includes(data.event)) return;
        onMessage(data);
      },
    });
  }, [productId, onMessage]);
}
